import { createSelector } from 'reselect';
import {
  NAV_SET_MENU_OPEN,
  NAV_SET_SIDE_MENU_OPEN
} from './constants';

let initialState = {
  menuOpen: false,
  sideMenuOpen: false
};

const nav = (state = initialState, action) => {
  switch (action.type) {
    case NAV_SET_MENU_OPEN:
      return { ...state, menuOpen: action.isOpen, sideMenuOpen: action.isOpen };
    case NAV_SET_SIDE_MENU_OPEN:
      return { ...state, sideMenuOpen: action.isOpen };
  }
  return state;
};

const menuOpen = state => state.nav.menuOpen;
const sideMenuOpen = state => state.nav.sideMenuOpen;

export const menuIsOpen = createSelector(
  menuOpen, menu => menu
);

export const sideMenuIsOpen = createSelector(
  sideMenuOpen, open => open
);

export default nav;
